//css
import "./Login.css";
//components
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";
import FormControl from "react-bootstrap/FormControl";
import Form from "react-bootstrap/Form";
import { useState, useEffect } from "react";
import Loader from "../common/Loader";
import { loginUser } from "../../service/authService";
import Image from "react-bootstrap/Image";
import { LANGUAGES } from "../common/constant";

//images
import showPassword from "../../assets/images/showPassword.png";
import dontShowPassword from "../../assets/images/dontShowPassword.png";
import { useTranslation } from "react-i18next";
import { Container, Row, Col } from "react-bootstrap";

function Login(props) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [language, setLanguage] = useState("");
  const [errormsg, setErrorMsg] = useState("");
  const [passwordType, setPasswordType] = useState("password");
  const { t } = useTranslation();
  {
    /* Use a suspense component in the parent or above component to not trigger error */
  }

  useEffect(() => {
    setLanguage(props.leadLanguage ? props.leadLanguage : "en");
    props.setTab("login");
  }, [props]);

  async function initiateLogin() {
    setLoading(true);
    localStorage.removeItem("leadUser");
    localStorage.removeItem("tempWashInventory");
    localStorage.removeItem("selectedOrgId");
    let resultSet = null;
    var userData = { userName: username, password: password };
    var response = await loginUser(userData);
    setLoading(false);
    if (response.status === 200) {
      resultSet = response.data.response;
      var localLanguage = localStorage.getItem("leadLanguage");
      props.onSave(localLanguage ? localLanguage : "en");
    } else {
      setErrorMsg("Username or password incorrect.");
    }
    return resultSet;
  }

  const isEmptyString = (strValue) => {
    if (!strValue.trim().length) {
      return false;
    } else {
      return true;
    }
  };

  async function getCredentials(e) {
    e.preventDefault();
    var flag = false;
    if (isEmptyString(username) && isEmptyString(password)) {
      flag = true;
    }
    if (flag) {
      let result = await initiateLogin();
      props.onLogin(result);
    } else {
      setErrorMsg("Username or password incorrect.");
    }
  }

  return (
    <Container className="login_window">
      <Row className="login-head login-form">
        <div className="login-heading">Sprayzapp</div>
      </Row>
      <Row className="login-form">
        <Row>
          <Form.Label className="login-headline">
            {t("username.label")}
          </Form.Label>
          <InputGroup className="mb-3">
            <FormControl
              id="username"
              className="input_item"
              aria-label="Default"
              aria-describedby="inputGroup-sizing-default"
              value={username}
              onChange={(e) => {
                setErrorMsg("");
                setUsername(e.target.value);
              }}
            />
          </InputGroup>
          <Form.Label className="login-headline">
            {t("password.label")}
          </Form.Label>
          <InputGroup className="mb-3">
            <FormControl
              type={passwordType}
              className="input_item"
              aria-label="Default"
              aria-describedby="inputGroup-sizing-default"
              value={password}
              onChange={(e) => {
                setErrorMsg("");
                setPassword(e.target.value);
              }}
            />
            <Image
              className="password-visible-btn"
              src={passwordType === "" ? showPassword : dontShowPassword}
              height="60%"
              style={{ cursor: "pointer", padding: "0px 15px" }}
              onClick={(e) =>
                passwordType === ""
                  ? setPasswordType("password")
                  : setPasswordType("")
              }
            ></Image>
          </InputGroup>
          {errormsg === "" ? (
            ""
          ) : (
            <div className="credential_message" id="credential_error">
              {errormsg}
            </div>
          )}
        </Row>
        <Row>
          <a href="/forgotpassword" className="forgot-password-label">
            {t("forgotPassword.label")}
          </a>
        </Row>
        <Row style={{ paddingTop: "10px" }}>
          <Form.Label className="login-headline">
            {t("language.label")}
          </Form.Label>
          <InputGroup className="mb-3">
            <Form.Select
              value={language}
              style={{ width: "max-content" }}
              onChange={(e) => {
                setLoading(true);
                setLanguage(e.target.value);
                props.onSave(e.target.value);
                setLoading(false);
              }}
            >
              <option value="">Select</option>
              {LANGUAGES.map((obj) => {
                return (
                  <option key={obj.code} value={obj.code}>
                    {obj.language}
                  </option>
                );
              })}
            </Form.Select>
          </InputGroup>
        </Row>

        <Row style={{ margin: "auto" }}>
          <Button
            variant="primary"
            className="login-btn"
            size="lg"
            active
            onClick={getCredentials}
          >
            {loading ? (
              <Loader
                loading={loading}
                loader={"loader  loader-login"}
                loaderColor={"#ffffff"}
                size={4}
              />
            ) : (
              <div className="login-btn-label">{t("login.label")}</div>
            )}
          </Button>{" "}
        </Row>
      </Row>
    </Container>
  );
}

export default Login;
